<div class="form-group">
    <form [formGroup]="mobileForm" class="common-intl-phone-form">
      <ngx-intl-tel-input
        [cssClass]="'form-control common-intl-phone'"
        [preferredCountries]="[CountryISO.India, CountryISO.UnitedStates]"
        [enableAutoCountrySelect]="false"
        [enablePlaceholder]="false"
        [searchCountryFlag]="true"
        [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
        [selectFirstCountry]="false"
        [selectedCountryISO]="CountryISO.India"
        [phoneValidation]="true"
        [separateDialCode]="true"
        customPlaceholder="MOBILE NUMBER"
        maxLength="10"
        name="phone"
        formControlName="phone"
        customPlaceholder="MOBILE NUMBER"
        (keyup)="doSearch($event); isErrorMessage($event)"
      >
      </ngx-intl-tel-input>
  
      <mat-error *ngIf="m.phone.touched && m.phone.errors?.pattern">
        Pattern mis match
      </mat-error>
      
      <button
        type="button"
        class="btn btn-primary btn-danger"
        (click)="signup()"
        [disabled]="!customValid || !mobileNumberValid"
      >
        {{btnText}}
      </button>
    </form>
  </div>
  